"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Parameters;

(function (Parameters) {
  var CustomParameter =
  /** @class */
  function () {
    /**
     * Custom parameter
     * @constructor
     * @param {string} name - Name of the parameter
     * @param {string} value - Value of the parameter
     */
    function CustomParameter(name, value) {
      this.name = name;
      this.value = value;

      if (!name) {
        throw Error("Name of the custom parameter is not specified");
      }
    }

    CustomParameter.prototype.getParam = function () {
      return this.name;
    };

    CustomParameter.prototype.getParamValue = function () {
      return this.value;
    };

    return CustomParameter;
  }();

  Parameters.CustomParameter = CustomParameter;
})(Parameters = exports.Parameters || (exports.Parameters = {}));